export const REGISTRATION_HOME_LOAD = "REGISTRATION_HOME_LOAD";
